import React, { Component } from 'react';
import { Route } from 'react-router';
import { Switch, BrowserRouter } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Login } from './components/Login';
import NotFoundPage from './components/NotFoundPage';

import './style.css'


export default class App extends Component {
  static displayName = App.name;

  render() {
    console.log(process.env.PUBLIC_URL);
    return (
      <Layout>
        <BrowserRouter basename={process.env.PUBLIC_URL}>
          <Switch>
            <Route exact path='/' component={Login} />
            <Route exact path='/mynsuinternational' component={Login} />
            <Route component={NotFoundPage} />

          </Switch>
        </BrowserRouter>
      </Layout>
    );
  }
}
